// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yJg2vHjVBHwH1NQYMWgc {
    padding: 24px 28px 20px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    touch-action: pan-y;
    font-family: var(--curio-font-family);
    color: var(--curio-text-primary);
    background: var(--curio-page-bg);
}

.WmIvxydQU4jL3TTawz37 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--curio-text-primary);
}

.GiUHKaXy2Qyw7josVcrs {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    /* The room for the close button and the space under the heading belong
       to the row. On the heading they pushed the READ-ONLY badge 42 px away
       and set it 3 px below the heading's centre line (#520). */
    padding-right: 32px;
    margin-bottom: 6px;
}

.vxwpP7pHlNKUUY7tPq12 {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    background: var(--curio-surface-muted);
    color: var(--curio-text-secondary);
    font-size: var(--curio-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    border: 1px solid var(--curio-border);
}

.ZDYfirOcl8krRRJe07s3 {
    margin: 0 0 16px;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
    line-height: 1.4;
}

.adELUNSV13y0bAz_PkHr {
    margin: 18px 0 8px;
    font-size: var(--curio-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--curio-text-muted);
}

.adELUNSV13y0bAz_PkHr:first-of-type {
    margin-top: 0;
}

.WPC2Fy9xnfuHmb0fqyml {
    margin-bottom: 12px;
}

.mkhicSnkiJFkcg81rHXO {
    display: block;
    font-size: var(--curio-font-size-md);
    font-weight: 500;
    color: var(--curio-text-primary);
    margin-bottom: 4px;
}

.CjDtcsoWczNDS97Izc57 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.mZeupZK9R5dJa0EKKgwl,
.gDJH5lpqQS45MBjfje7w,
.Ss1pCMPwqOa5_raokoBm {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-md);
}

.mZeupZK9R5dJa0EKKgwl:focus,
.gDJH5lpqQS45MBjfje7w:focus,
.Ss1pCMPwqOa5_raokoBm:focus {
    outline: none;
    border-color: var(--curio-top-bar-bg);
}

.gDJH5lpqQS45MBjfje7w {
    min-height: 160px;
    resize: vertical;
    font-family: "JetBrains Mono", "SF Mono", Menlo, monospace;
    font-size: var(--curio-font-size-sm);
    line-height: 1.45;
}

.CEpKJNJg07zXkURNgPJF {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 12px;
}

.uITzpNJGxr2wtWfz56ix {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
}

/* One bordered block per port, holding its cardinality and its type rows.
   Replaces .portRow, which laid out a single "types, cardinality, remove" line
   back when every type of a port lived in one comma-separated field (#219). */
.gwZrsJJO5SUdlDfyLseh {
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-md);
    padding: 10px;
    margin-bottom: 10px;
}

.AmvXAZK_ljGMS61PvUPg {
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
}

.E8anE2MPMPCVmCnyJhGH {
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
}

/* Two columns, so a port declaring all six types is three rows rather than six
   -- computation-analysis declares six. */
.oO89Z534UIL0qHCB8kM7 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 8px;
}

.v43WfcZXPQRXrG_77uZb {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 6px;
    align-items: center;
}

.RA59OSyBa7t9lqSayExP:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.RA59OSyBa7t9lqSayExP {
    background: var(--curio-card-bg);
    border: 1px solid var(--curio-border-strong);
    padding: 6px 12px;
    border-radius: var(--curio-radius-md);
    cursor: pointer;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
}

.RA59OSyBa7t9lqSayExP:hover {
    background: var(--curio-page-bg);
}

.VizzwBIxZ6cQ5rWimxm4 {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid var(--curio-border);
}

.VoWwABNovIpZ8l39OkIV {
    padding: 0 16px;
    height: var(--curio-input-height);
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 500;
    cursor: pointer;
}

.VoWwABNovIpZ8l39OkIV:hover {
    background: var(--curio-page-bg);
}

.edNGrMumkNPrlUAEkuzz {
    padding: 0 20px;
    height: var(--curio-input-height);
    border: none;
    border-radius: var(--curio-radius-md);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 600;
    cursor: pointer;
}

.edNGrMumkNPrlUAEkuzz:hover {
    background: var(--curio-top-bar-bg-hover);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/editing/NodeTemplateConfigModal.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf;;gEAE4D;IAC5D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,kCAAkC;IAClC,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;;IAGI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;AACxC;;AAEA;;;IAGI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0DAA0D;IAC1D,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;8EAE8E;AAC9E;IACI,qCAAqC;IACrC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;0CAC0C;AAC1C;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;IACf,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":[".content {\n    padding: 24px 28px 20px;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    overscroll-behavior: contain;\n    touch-action: pan-y;\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-primary);\n    background: var(--curio-page-bg);\n}\n\n.title {\n    margin: 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.titleRow {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    /* The room for the close button and the space under the heading belong\n       to the row. On the heading they pushed the READ-ONLY badge 42 px away\n       and set it 3 px below the heading's centre line (#520). */\n    padding-right: 32px;\n    margin-bottom: 6px;\n}\n\n.readOnlyBadge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 4px;\n    background: var(--curio-surface-muted);\n    color: var(--curio-text-secondary);\n    font-size: var(--curio-font-size-xs);\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    border: 1px solid var(--curio-border);\n}\n\n.subtitle {\n    margin: 0 0 16px;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n    line-height: 1.4;\n}\n\n.sectionTitle {\n    margin: 18px 0 8px;\n    font-size: var(--curio-font-size-xs);\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--curio-text-muted);\n}\n\n.sectionTitle:first-of-type {\n    margin-top: 0;\n}\n\n.field {\n    margin-bottom: 12px;\n}\n\n.fieldLabel {\n    display: block;\n    font-size: var(--curio-font-size-md);\n    font-weight: 500;\n    color: var(--curio-text-primary);\n    margin-bottom: 4px;\n}\n\n.row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n}\n\n.input,\n.textarea,\n.select {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 8px 10px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n}\n\n.input:focus,\n.textarea:focus,\n.select:focus {\n    outline: none;\n    border-color: var(--curio-top-bar-bg);\n}\n\n.textarea {\n    min-height: 160px;\n    resize: vertical;\n    font-family: \"JetBrains Mono\", \"SF Mono\", Menlo, monospace;\n    font-size: var(--curio-font-size-sm);\n    line-height: 1.45;\n}\n\n.checkGrid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px 12px;\n}\n\n.checkRow {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n}\n\n/* One bordered block per port, holding its cardinality and its type rows.\n   Replaces .portRow, which laid out a single \"types, cardinality, remove\" line\n   back when every type of a port lived in one comma-separated field (#219). */\n.portGroup {\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-md);\n    padding: 10px;\n    margin-bottom: 10px;\n}\n\n.portGroupHeader {\n    display: grid;\n    grid-template-columns: 1fr auto auto;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.portGroupTitle {\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n}\n\n/* Two columns, so a port declaring all six types is three rows rather than six\n   -- computation-analysis declares six. */\n.typeGrid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.typeRow {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 6px;\n    align-items: center;\n}\n\n.smallBtn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.smallBtn {\n    background: var(--curio-card-bg);\n    border: 1px solid var(--curio-border-strong);\n    padding: 6px 12px;\n    border-radius: var(--curio-radius-md);\n    cursor: pointer;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n}\n\n.smallBtn:hover {\n    background: var(--curio-page-bg);\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 16px;\n    padding-top: 12px;\n    border-top: 1px solid var(--curio-border);\n}\n\n.ghostBtn {\n    padding: 0 16px;\n    height: var(--curio-input-height);\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.ghostBtn:hover {\n    background: var(--curio-page-bg);\n}\n\n.primaryBtn {\n    padding: 0 20px;\n    height: var(--curio-input-height);\n    border: none;\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.primaryBtn:hover {\n    background: var(--curio-top-bar-bg-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `yJg2vHjVBHwH1NQYMWgc`,
	"title": `WmIvxydQU4jL3TTawz37`,
	"titleRow": `GiUHKaXy2Qyw7josVcrs`,
	"readOnlyBadge": `vxwpP7pHlNKUUY7tPq12`,
	"subtitle": `ZDYfirOcl8krRRJe07s3`,
	"sectionTitle": `adELUNSV13y0bAz_PkHr`,
	"field": `WPC2Fy9xnfuHmb0fqyml`,
	"fieldLabel": `mkhicSnkiJFkcg81rHXO`,
	"row": `CjDtcsoWczNDS97Izc57`,
	"input": `mZeupZK9R5dJa0EKKgwl`,
	"textarea": `gDJH5lpqQS45MBjfje7w`,
	"select": `Ss1pCMPwqOa5_raokoBm`,
	"checkGrid": `CEpKJNJg07zXkURNgPJF`,
	"checkRow": `uITzpNJGxr2wtWfz56ix`,
	"portGroup": `gwZrsJJO5SUdlDfyLseh`,
	"portGroupHeader": `AmvXAZK_ljGMS61PvUPg`,
	"portGroupTitle": `E8anE2MPMPCVmCnyJhGH`,
	"typeGrid": `oO89Z534UIL0qHCB8kM7`,
	"typeRow": `v43WfcZXPQRXrG_77uZb`,
	"smallBtn": `RA59OSyBa7t9lqSayExP`,
	"footer": `VizzwBIxZ6cQ5rWimxm4`,
	"ghostBtn": `VoWwABNovIpZ8l39OkIV`,
	"primaryBtn": `edNGrMumkNPrlUAEkuzz`
};
export default ___CSS_LOADER_EXPORT___;
